import { treaty } from "@elysiajs/eden"
import type { AdminApi } from "@/api/elysia/admin-api"
import type { ChatApi } from "@/api/elysia/chat-api"
import type { DashboardApi } from "@/api/elysia/dashboard-api"
import type { DealsApi } from "@/api/elysia/deals-api"
import type { ProfileApi } from "@/api/elysia/profile-api"
import type { StreakApi } from "@/api/elysia/streak-api"

function getApiBaseUrl() {
  if (typeof window !== "undefined") return window.location.origin
  return process.env.APP_ORIGIN || "http://localhost:3000"
}

const apiBaseUrl = getApiBaseUrl()

export const adminTreatyClient = treaty<AdminApi>(apiBaseUrl)
export const chatTreatyClient = treaty<ChatApi>(apiBaseUrl)
export const dashboardTreatyClient = treaty<DashboardApi>(apiBaseUrl)
export const dealsTreatyClient = treaty<DealsApi>(apiBaseUrl)
export const profileTreatyClient = treaty<ProfileApi>(apiBaseUrl)
export const streakTreatyClient = treaty<StreakApi>(apiBaseUrl)
